import React from 'react'
import { Grid, makeStyles, Typography } from '@material-ui/core'
import SearchField from './SearchField'
import LinkSelect from './LinkSelect'
import SearchBtn from './SearchBtn'
import Chips from '../FilterSet'
import Headline from '../Headline'
import FilterTemplate from '../SelectTemplate'

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(8)
  }
}))

const MainSearch = () => {
  const classes = useStyles()
  return (
    <Grid className={classes.root} container spacing={2}>
      <Grid item xs={12}>
        <Headline />
        <FilterTemplate />
      </Grid>
      <Grid item xs={4}>
        <SearchField />
      </Grid>
      <Grid item>
        <LinkSelect />
      </Grid>
      <Grid item xs={2}>
        <SearchBtn />
      </Grid>
      <Grid item xs={12}>
        <Chips />
      </Grid>
    </Grid>
  )
}

export default MainSearch
